import * as React from "react";
import { useState, useContext } from "react";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Typography, Alert, Button, Paper, TextField } from "@mui/material";
import MainContext from "../../../../../context/mainContext";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import { deleteSubtitlesApi, findSubtitlesWithIdApi } from "../../../../../services/subtitlesApi";

const SEARCH_URL = `${process.env.REACT_APP_SITEURL}/sub`;

export default function SearchSubtitles() {
  const [subtitlesId, setSubtitlesId] = React.useState("");
  const [confirmSubtitlesId, setConfirmSubtitlesId] = React.useState("");
  const [userId, setUserId] = React.useState("");
  const [removeAccess, setRemoveAccess] = React.useState(false);
  const [season, setSeason] = React.useState("");
  const [episode, setEpisode] = React.useState("");
  const [subtitlesLanguage, setSubtitlesLanguage] = React.useState("");
  const [coverUrl, setCoverUrl] = useState(false);
  const [nameOfMovie, setNameOfMovie] = useState("");
  const [typeOfVideo, setTypeOfVideo] = useState("");
  const [uploadType, setUploadType] = useState(null);
  const {
    userTypes,
  } = useContext(MainContext);


  const searchSubtitle = async (type, data, paginate) => {
    setRemoveAccess(false)
    if (subtitlesId.length < 1) customToastify("warning", "لطفا آی دی زیرنویس را وارد کنید");
    else {
      let toastMsg = toast.loading("لطفا صبر کنید...")
      try {
        let response = await findSubtitlesWithIdApi({ subtitlesUploadId: subtitlesId });
        const resData = checkResponseData(response);
        if (resData["success"]) {
          if (resData["data"]["data"][0]["subtitlesUploadId"]) {
            setConfirmSubtitlesId(resData["data"]["data"][0]["subtitlesUploadId"])
            if (resData["data"]["data"][0]["season"]) {
              setTypeOfVideo("Serial")
              setSeason(resData["data"]["data"][0]["season"])
              setEpisode(resData["data"]["data"][0]["episode"])
            }
            setSubtitlesLanguage(resData["data"]["data"][0]["subtitlesLanguage"])
            setCoverUrl(resData["data"]["data"][0]["coverUrl"])
            setNameOfMovie(resData["data"]["data"][0]["nameOfMovie"])
            setUploadType(resData["data"]["data"][0]["type"])
            toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
            if (userTypes.includes("subtitlesManager") || userTypes.includes("admin") || resData["data"]["data"][0]["userId"] == userId) setRemoveAccess(true)
          } else {
            toast.update(toastMsg, { render: "زیرنویسی با این آی دی وجود ندارد", type: "error", isLoading: false, autoClose: 3000 });
          }
        } else {
          toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        }
      } catch (error) {
        const errData = checkErrorMessage(error);
        let errMsg = errData["titles"] || errData["message"]
        console.log("errData,", errMsg)
        toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      }
    }
  }

  const removeSubtitles = async () => {
    let toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      let response = await deleteSubtitlesApi({ subtitlesUploadId: confirmSubtitlesId });
      const resData = checkResponseData(response);
      if (resData["success"]) {
        setConfirmSubtitlesId("")
        setTypeOfVideo("")
        setSeason("")
        setEpisode("")
        setSubtitlesLanguage("")
        setCoverUrl(false)
        setNameOfMovie("")
        setUploadType("")
        setRemoveAccess(false)
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      console.log("errData,", errMsg)
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }
  }

  function CheckUserId() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token) {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        const getUserId = JSON.parse(jsonPayload)["id"];
        setUserId(getUserId)
      } else {
        setUserId("");
      }
    } catch {
      setUserId("");
    }
  }

  const getType = (uploadType) => {
    if (uploadType == "userUpload") return "معمولی"
    else if (uploadType == "managerUpload") return "متوسط"
    else if (uploadType == "umlang") return "ویژه"
    else return null
  }
  React.useEffect(() => {
    CheckUserId()
  }, [])

  return (
    <Box sx={{ width: "100%", px: 1 }}>
      <Paper sx={{ p: 1 }}>
        <Typography sx={{ m: 1 }}>
          به منظور حذف زیرنویس ابتدا آی دی زیرنویس را وارد کنید و سپس دکمه بررسی را فشار دهید
        </Typography>
        <TextField value={subtitlesId} size="small" label="آی دی زیرنویس" variant="outlined"
          onChange={(e) => { setSubtitlesId(e.target.value) }}
          sx={{ mx: 1 }} />
        {removeAccess ? <>
          <Button sx={{ mx: 1 }} variant="contained"
            onClick={searchSubtitle}
          >بررسی دوباره</Button>
          <Button sx={{ mx: 1 }} variant="contained" color="error"
            onClick={removeSubtitles}
          >حذف زیرنویس</Button>
        </> : <Button sx={{ mx: 1 }} variant="contained"
          onClick={searchSubtitle}
        >بررسی</Button>}

      </Paper >
      {removeAccess ?
        <Paper sx={{ mt: 1, pt: 1 }}>
          <Typography sx={{ m: 1 }}>
            <span style={{ width: "100px", display: "inline-flex" }} >آی دی</span>
            <span>{confirmSubtitlesId}</span>
          </Typography>
          <Typography sx={{ m: 1 }}>
            <span style={{ width: "100px", display: "inline-flex" }} >نام فیلم</span>
            <span>{nameOfMovie}</span>
          </Typography>
          {season ? <Typography sx={{ m: 1 }}>
            <span style={{ width: "100px", display: "inline-flex" }} >فصل</span>
            <span>{season}</span>
          </Typography> : null}
          {episode ?
            <Typography sx={{ m: 1 }}>
              <span style={{ width: "100px", display: "inline-flex" }} >قسمت</span>
              <span>{episode}</span>
            </Typography> : null}
          <Typography sx={{ m: 1 }}>
            <span style={{ width: "100px", display: "inline-flex" }} >زبان زیرنویس</span>
            <span>{subtitlesLanguage}</span>
          </Typography>
          <Typography sx={{ m: 1 }}>
            <span style={{ width: "100px", display: "inline-flex" }} >نوع زیرنویس</span>
            <span>{getType(uploadType)}</span>
          </Typography>
          <img alt="" src={coverUrl} />
        </Paper> : null
      }

    </Box>
  );
}
